// extracted by mini-css-extract-plugin
module.exports = {"reviewItem":"styles_reviewItem__u0LY4","wrapper":"styles_wrapper__O1KhU"};